
<modal-window :main-width="9">
  <loading-spinner v-if="loading"></loading-spinner>
  <div v-if="!loading">
    <h2>Template Availability</h2>
    <p>Here you can set at which places in the application this template will be available.</p>
    <ul>
      <li>Board - Template is available next to "Create new Task" for manual creation</li>
      <li>Technical Occurrence / COMAT - Template is available for usage in Special Occurrence</li>
    </ul>

    <table class="table table-striped">
      <thead>
        <tr>
          <th>Available</th>
          <th>Type</th>
          <th>SortOrder</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="availability in availabilites" :key="availability.specialOccurrenceType">
          <td>
            <b-form-checkbox class="mb-1" v-model="availability.isAvailable" :value="true" :unchecked-value="false">
              Is available
            </b-form-checkbox>
          </td>
          <td>{{ availability.specialOccurrenceType.toLowerCase() == 'none' ? 'Board' : availability.specialOccurrenceType }}</td>

          <td>
            <input type="number" :disabled="!availability.isAvailable" class="form-control form-control-sm" v-model="availability.sortOrder" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <template #sidebar>
    <div class="d-flex flex-column justify-content-end h-100">
      <div class="label mb-2">
        <button class="btn btn-block btn-sm btn-info" @click="close">
          <i class="far fa-times"></i>
          Cancel
        </button>
      </div>
      <div class="label mb-2">
        <button class="btn btn-block btn-sm btn-success" @click="saveAndClose">
          <i class="far fa-save"></i>
          Save and close
        </button>
      </div>
    </div>
  </template>
</modal-window>
